<template>
  <div class="bootcamp-page">
    <el-card>
      <el-form :inline="true" :model="filter" size="small">
        <el-form-item label="手机号：">
          <el-input v-model="filter.phone" placeholder="请输入手机号" />
        </el-form-item>
        <el-form-item label="添加时间：">
          <el-date-picker
            v-model="date1"
            value-format="yyyy-MM-dd"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="search">查询</el-button>
          <el-button type="" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-row class="operate-line">
        <el-button type="primary" size="small" @click="addAccount">添加帐号</el-button>
      </el-row>
    </el-card>
    <el-card style="margin-top: 10px;">
      <el-table v-loading="loading" :data="list" border style="margin-top: 10px">
        <el-table-column align="center" label="id" prop="id" width="180px" />
        <el-table-column align="center" label="手机号" prop="phone" />
        <el-table-column align="center" label="二维码" width="84px">
          <template v-slot="{ row }">
            <el-image class="qr-code" :src="row.qrCode" :preview-src-list="[row.qrCode]" />
          </template>
        </el-table-column>
        <el-table-column align="center" label="添加时间" prop="insertDate" />
        <el-table-column align="center" label="状态" prop="state">
          <template v-slot="{ row }">
            <span v-if="row.state === 1">启用</span>
            <span v-else>禁用</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" prop="" width="200" fixed="right">
          <template v-slot="{ row }">
            <el-button type="text" class="operate-button" @click="handleEdit(row)">编辑账号</el-button>
            <el-button type="text" class="operate-button" @click="viewStudent(row.id)">查看学员</el-button>
            <el-button type="text" class="operate-button" @click="toggleStatus(row.id)">
              {{ row.state === 1 ? '禁用' : '启用' }}
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        style="margin-top: 10px; text-align: center;"
        :current-page="filter.page"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="filter.limit"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </el-card>
    <!-- 编辑/添加账号 -->
    <el-dialog
      :title="`${crewForm.id ? '编辑' : '添加'}账号`"
      width="600px"
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      :before-close="handleClose">
      <el-form
        ref="crewFormEl"
        :model="crewForm"
        :rules="rules"
        size="small"
        label-width="120px"
      >
        <el-form-item label="手机号" prop="phone">
          <el-input
            type="tel"
            v-model="crewForm.phone"
            placeholder="请输入手机号"
          />
        </el-form-item>
        <el-form-item label="二维码" prop="qrCode">
          <div class="pic" v-if="crewForm.qrCode">
            <i class="el-icon-delete" @click="handleDelImage" />
            <img style="width:60px;height: 60px" :src="crewForm.qrCode">
          </div>
          <ImgUpload
            ref="imgUploadEl"
            accept=".jpg,.JPG,.png,.PNG,.jpeg,.JPEG"
            :max="1"
            :size="2048"
            @input="onUpload"
          />
          <p class="upload-tips">最多可上传1张图片，图片格式为jpg、jpeg、png，不大于2M</p>
        </el-form-item>
        <el-form-item label="状态">
          <el-radio-group v-model="crewForm.state">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="" size="small" @click="handleClose">取消</el-button>
        <el-button type="primary" size="small" @click="handleSubmit">保存</el-button>
      </span>
    </el-dialog>
    <StudentDialog ref="studentDialogEl" />
  </div>
</template>

<script>
import { getListPage, editActivityMediaSale, updateState } from '@/api/admin/bootcamp.js'
import ImgUpload from '@/components/upload/file'
import StudentDialog from './components/studentDialog'

export default {
  name: 'Bootcamp',

  components: { ImgUpload, StudentDialog },
  data() {
    return {
      loading: false,
      filter: {
        page: 1,
        limit: 10,
        phone: '',
        startDate: '',
        endDate: '',
      },
      total: 0,
      list: [],
      dialogVisible: false,
      crewForm: {
        phone: '',
        qrCode: '',
        state: 1
      },
      rules: {
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
        ],
        qrCode: [
          { required: true, message: '请上传二维码!', trigger: 'blur' }
        ]
      }
    }
  },
  computed: {
    date1: {
      get() {
        return [this.filter.startDate, this.filter.endDate]
      },
      set(v) {
        if (v && v.length) {
          this.filter.startDate = v[0] + ' 00:00:00' || ''
          this.filter.endDate = v[1] + ' 23:59:59' || ''
        } else {
          this.filter.startDate = ''
          this.filter.endDate = ''
        }
      }
    }
  },
  created() {
    this.getList()
  },
  methods: {
    getList (refresh = true) {
      this.loading = refresh
      getListPage(this.filter).then(({ code, data }) => {
        if (code === 0) {
          this.list = data.records
          this.total = Number(data.total)
        }
      }).finally(() => {
        this.loading = false
      })
    },
    // 搜索
    search() {
      this.filter.page = 1
      this.getList()
    },
    // 重置
    reset() {
      const d = this.$options.data()
      this.filter = d.filter
      this.total = 0
      this.list = []
      this.getList()
    },
    // 添加帐号
    addAccount() {
      this.dialogVisible = true
      this.$refs.imgUploadEl && this.$refs.imgUploadEl.clearFiles()
    },
    handleEdit({ id, phone, qrCode, state }) {
      this.crewForm = { id, phone, qrCode, state }
      this.dialogVisible = true
      this.$refs.imgUploadEl && this.$refs.imgUploadEl.clearFiles()
    },
    viewStudent(id) {
      this.$refs.studentDialogEl.init(id)
    },
    toggleStatus(id) {
      updateState({ id }).then(({ code }) => {
        if (code === 0) {
          this.$message.success('修改成功!')
          this.getList(false)
        }
      })
    },
    // 上传图片
    onUpload(url) {
      this.crewForm.qrCode = url
    },
    handleDelImage() {
      this.crewForm.qrCode = ''
      this.$refs.imgUploadEl.clearFiles()
    },
    handleSubmit() {
      this.$refs.crewFormEl.validate(valid => {
        if (valid) {
          if (this.crewForm.phone.length !== 11) {
            this.$message.warning('请输入正确手机号码!')
            return
          }
          editActivityMediaSale(this.crewForm).then(({ code }) => {
            if (code === 0) {
              this.$message.success(`${this.crewForm.id ? '编辑' : '添加'}成功!`)
              this.getList(false)
              this.handleClose()
            }
          })
        }
      })
    },
    handleSizeChange(v) {
      this.filter.page = 1
      this.filter.limit = v
      this.getList()
    },
    handleCurrentChange(v) {
      this.filter.page = v
      this.getList()
    },
    handleClose() {
      this.dialogVisible = false
      this.crewForm = this.$options.data().crewForm
    },
  }
}
</script>

<style lang="scss" scoped>
.bootcamp-page {
  ::v-deep .pic {
    display: inline-block;
    width: 60px;
    height: 60px;
    position: relative;
    i {
      display: none;
      transition: all 0.16s ease-in;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;
      line-height: 60px;
      text-align: center;
      background-color: #CCCCCC;
      font-size: 26px;
      opacity: 0;
      cursor: pointer;
    }
    &:hover {
      i {
        display: inline-block;
        opacity: 0.8;
      }
    }
  }
}
.qr-code {
  width: 40px;
  height: 40px;
  vertical-align: middle;
}
.operate-button {
  padding: 0;
}
</style>
